export default __webpack_public_path__ + "static/media/user-icon.00a0d646.svg";